import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";

import "./AITestDetailsInsight.css";

const AITestDetailsInsight = ({ testData }) => {
  const [aiResponse, setAiResponse] = useState("");
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);
  const responseRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    const fetchAIResponse = async () => {
      const apiUrl =
        window.configs.BASE_API_URL +
        window.configs.TEST_ERROR_INSIGHT_URL;
      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(testData),
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;

          const chunk = decoder.decode(value, { stream: true });
          if (isMounted) {
            setAiResponse((prev) => prev + chunk);
          }
        }
      } catch (err) {
        if (isMounted) setErrorMsg(err.message);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchAIResponse();

    return () => {
      isMounted = false;
    };
  }, [testData]);

  useEffect(() => {
    //scrolling to bottom
    const scrollContainer =
      responseRef.current?.parentElement?.parentElement?.parentElement
        ?.parentElement;
    if (scrollContainer) {
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }
  }, [aiResponse]);

  return (
    <div className="ai-container" ref={responseRef}>
      {errorMsg && <div className="error">{errorMsg}</div>}

      <div className="response-box">
        <ReactMarkdown>{aiResponse}</ReactMarkdown>
      </div>

      {loading && (
        <div className="spinner-container">
          <div className="spinner" />
        </div>
      )}
    </div>
  );
};

export default AITestDetailsInsight;
